// extracted by mini-css-extract-plugin
export var container = "GarminInformationalModal-module__container___nYnlA";
export var img = "GarminInformationalModal-module__img___MCb7U";
export var title = "GarminInformationalModal-module__title___nsRcv";